import React from "react";
import {withStyles} from "@mui/styles";
import {FormattedMessage} from "react-intl";
import FilterChip from "views/marketplace/merchandising/filter/filterChip";
import filterMenuStyle from "assets/jss/components/filterMenuStyle";

// one column of pills per status group (status / validity / on eshop), each
// under a blue title — same layout as the product list's Status tab
function StatusFilterPanel({items, classes}) {
    return (
        <div className={classes.statusStockFilter}>
            {items.map((filter, index) => (
                <div className={classes.filterInColumn} key={index}>
                    <span className={classes.filterBlueTitle}>
                        <FormattedMessage id={"merchandising.show.label.filters.title." + filter.tabTitle} />
                    </span>
                    {filter.tabContent.items.map((item, itemIndex) => (
                        <FilterChip
                            key={itemIndex}
                            label={<FormattedMessage id={"merchandising.show.label.filters." + item.name} />}
                            item={item}
                        />
                    ))}
                </div>
            ))}
        </div>
    );
}

export default withStyles(filterMenuStyle)(StatusFilterPanel);
